import { createReducer } from 'redux-act';
// project files
import * as actions from './actions';

const initialState = {
  supervisorUsers: true,
  organizations: [],
  currentOrganization: {
    name: '',
    address: '',
    wifiDetails: '',
    bio: '',
    logo: '',
    code: '',
  },
  orgUsers: [],
  users: [],
  vocabs: {},
  pastLessons: [],
  orgBookingLesson: {
    orgStudentsLessons: [],
    lessonNote: '',
  },
  orgBookingOralScores: [],
  orgCurriculum: '',
  orgTagsUsers: [],
  tags: [],
  studentChallenges: [],
  previewOrgDetails: {
    code: '',
    createdAt: '',
    lesson: null,
    logo: '',
    name: '',
    updatedAt: '',
    videoFrameRate: 0,
    videoResolution: '',
    terms: [],
  },
  previewUserDetails: {
    firstName: '',
    lastName: '',
    avatar: '',
    createdAt: '',
  },
  recentQuizScoresByType: {
    listening: null,
    reading: null,
  },
  userQuizScores: [],
  orgUser: null,
  lastWritingPad: {},
  bookingOptions: {},
};

const manageOrganizationsReducer = createReducer(
  {
    [actions.toggleSupervisorUsers]: (state, payload) => ({
      ...state,
      supervisorUsers: payload,
    }),
    [actions.fetchOrganizationsSuccess]: (state, payload) => ({
      ...state,
      organizations: payload,
    }),
    [actions.fetchOrganizationSuccess]: (state, payload) => ({
      ...state,
      currentOrganization: payload,
    }),
    [actions.fetchOrgBookingAlertSuccess]: (state, payload) => ({
      ...state,
      orgBookingAlert: payload,
    }),
    [actions.fetchOrganizationAdminsSuccess]: (state, payload) => ({
      ...state,
      orgAdmins: payload,
    }),
    [actions.clearVocabs]: (state) => ({
      ...state,
      vocabs: {},
    }),
    [actions.fetchVocabsSuccess]: (state, payload) => ({
      ...state,
      vocabs: payload,
    }),
    [actions.fetchPastUserLessonsSuccess]: (state, payload) => ({
      ...state,
      pastLessons: payload,
    }),
    [actions.fetchOrgBookingLessonSuccess]: (state, payload) => ({
      ...state,
      orgBookingLesson: {
        ...payload,
      },
    }),
    [actions.fetchStudentChallenges]: (state, payload) => {
      return {
        ...state,
        studentChallenges: payload,
      };
    },
    [actions.fetchPreviewOrganizationDetailsSuccess]: (state, payload) => {
      return {
        ...state,
        previewOrgDetails: { ...payload },
      };
    },
    [actions.fetchPreivewUserDetailsSuccess]: (state, payload) => {
      return {
        ...state,
        previewUserDetails: payload,
      };
    },
    [actions.fetchRecentQuizScoresByTypeSuccess]: (state, payload) => {
      return {
        ...state,
        recentQuizScoresByType: {
          ...state.recentQuizScoresByType,
          [payload.type]: payload,
        },
      };
    },
    [actions.fetchLessonsOralScoresSuccess]: (state, payload) => {
      return {
        ...state,
        orgBookingOralScores: payload,
      };
    },
    [actions.clearOrgUser]: (state) => {
      return {
        ...state,
        orgUser: null,
      };
    },
    [actions.clearOrgTagsUsers]: (state) => {
      return {
        ...state,
        orgTagsUsers: [],
      };
    },
    [actions.getLastWritingPadSuccess]: (state, payload) => {
      return {
        ...state,
        lastWritingPad: payload,
      };
    },
    [actions.getOrganizationBookingOptions]: (state, payload) => {
      return {
        ...state,
        bookingOptions: payload,
      };
    },
  },
  initialState
);

export default manageOrganizationsReducer;
